import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { rates } from "../../rbac-consts";
import AdminRatesTabsContainer from "./admin/RatesTabsContainer";
import ClientRatesTabsContainer from "./client/RatesTabsContainer";
import PairUnitManagerRatesTabsContainer from "./pairUnitManager/RatesTabsContainer";

const RatesWrapper = ({match}) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={rates.ADMIN}
        yes={() => (
          <AdminRatesTabsContainer match={match}/>
        )}
      />
      <Can
        role={user.roles}
        perform={rates.USER}
        yes={() => (
          <ClientRatesTabsContainer match={match}/>
        )}
      />
      <Can
        role={user.roles}
        perform={rates.PAIR_UNIT_MANAGER}
        yes={() => (
          <PairUnitManagerRatesTabsContainer match={match}/>
        )}
      />
    </>
  );
};

export default RatesWrapper;